import * as XLSX from 'xlsx';
import { CustomerMassQueryResult } from '../types/query';
import { Customer } from '../../Customer/Model/CustomerModel';

export const downloadExcelWithSheets = (
  data: CustomerMassQueryResult,
  customers: Customer[],
  filename = 'customers.xlsx',
) => {
  if (!data.length) return;

  const workbook = XLSX.utils.book_new();

  data.forEach((customerData) => {
    const [customerId, rows] = Object.entries(customerData)[0];

    if (!rows?.length) return;

    const customer = customers.find((c) => c.Id === customerId);
    const customerName = customer?.Subdomain ?? customerId;

    const worksheet = XLSX.utils.json_to_sheet(rows);

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      customerName.slice(0, 31),
    );
  });

  XLSX.writeFile(workbook, filename);
};
